import { useAtom } from 'jotai';

import {
    accommodationMetaAtom,
    flightMetaAtom,
    metaAtom,
    popularFilterListMetaAtom,
    priceRangeMetaAtom,
    specialMetaAtom,
    transferMetaAtom,
} from 'data/Atom/Meta';

export const useMeta = () => useAtom(metaAtom);

export const useAccommodationMeta = () => useAtom(accommodationMetaAtom);

export const useSpecialMeta = () => useAtom(specialMetaAtom);

export const usePopularFilterListMeta = () =>
    useAtom(popularFilterListMetaAtom);

export const useBugdetMeta = () => useAtom(priceRangeMetaAtom);

export const useTransferMeta = () => useAtom(transferMetaAtom);

export const useFlightMeta = () => useAtom(flightMetaAtom);
